/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDispatch, useSelector } from 'react-redux';
import { updatePublishDate, trackPublish, showPublishErrors
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/publishActions';
import { getSubcategory, getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { useCallback, useContext } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { fetchContent, fetchHardSavedContent
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/contentActions';
import { getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getShouldOpenPostPublishCustomDomainSetupModal, getShouldOpenPostPublishContentRemixModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { markActionComplete } from 'user-context/onboarding';
// @ts-expect-error Untyped module
import { PAGES_API_BASE_URL } from 'page-editor-ui/Constants';
// @ts-expect-error Untyped module
import { showThrottledPostPagePublishCsatSurvey } from 'ContentEditorUI/lib/csatSurvey';
import { getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getContentModelDynamicPageSourceValue, getDynamicPageSourceType } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { getIsSchedulingUpdate
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pagePublishSelectors';
import { displayPublishSuccessAlert } from 'ContentEditorUI/utils/displayPublishSuccessAlert';
import { getPageSettingsFullUrl } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import { togglePostPublishDomainSetupModal, openModal
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/actions/appActions';
import { PublishTypes } from 'ContentEditorUI/constants/PublishTypes';
import { getOnboardingToursTask, isFromPaymentsGuide } from 'payments-post-enroll-local-storage-lib/data/onboardingTours';
import { getActiveDomainIsConnected, getActiveDomainIsInternal } from 'ContentEditorUI/redux/selectors/portalDomainsSelectors';
import { getHasAnyLayoutSections } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getCategoryId } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
// @ts-expect-error Untyped module
import { getBaseApiUrl } from 'ContentEditorUI/redux/selectors/extraInitialStateSelectors';
import { getBaseContentUrl, fetch as fetchContentApi
// @ts-expect-error Untyped module
} from 'ContentEditorUI/api/ContentApi';
// @ts-expect-error Untyped module
import PublishApi from 'ContentEditorUI/api/PublishApi';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-expect-error Untyped module
import { save as saveAction } from '../redux/actions/pageSaveActions';
import { useAiLpThankYouPageReminder } from './useAiLpThankYouPageReminder';
import Raven from 'raven-js';
import { getIsUngatedForCMPPublishing } from '../redux/selectors/authSelectors';
import { isBannerEnabled } from 'onboarding-tours/util/banner';
import { DISCOVERY_MODE_GROUP_KEY, DISCOVERY_MODE_LANDING_PAGE_TASK_KEY } from 'marketing-discovery-utils/constants';
import { updateTaskStatus } from 'marketing-discovery-utils/api/discoveryTasksApi';
import { DISCOVERY_MODE_STEP_COMPLETED_MODAL } from '../constants/discoveryMode';
import { jsx as _jsx } from "react/jsx-runtime";
const HIDE_TASK_COMPLETION_MODAL = {
  showTaskCompletionModal: false
};
const getOnboardingToursGuideSessionStorageValue = () => {
  return JSON.parse(window.sessionStorage.getItem('ONBOARDING_TOURS_GUIDE') || '{}');
};
const showPagesCsatSurvey = (notStarterCustomerish, publishType) => {
  const isPublishingOrScheduling = publishType === PublishTypes.publish || publishType === PublishTypes.schedule;

  // Only show the survey to pages that were just published/scheduled (not updated)
  // ... and _not_ to customers in the LP starter beta (using a page from a starter template)
  if (isPublishingOrScheduling && notStarterCustomerish) {
    showThrottledPostPagePublishCsatSurvey();
  }
};

// Configured to only work with unified publish button setup
const usePublishLifecycleHandlers = setShowUseCaseTourCompleteModal => {
  const {
    tour
  } = useContext(TourContext);
  const {
    isEligibleForThankYouPageReminder,
    fetchThankYouPage,
    logError: logThankYouPageFetchError
  } = useAiLpThankYouPageReminder();
  const dispatch = useDispatch();
  const isLandingPage = useSelector(getIsLandingPage);
  const notStarterCustomerish = useSelector(getIsAdvancedPageTemplateOrHasAdvancedFeaturesAccess);
  const dynamicPagesSource = useSelector(getDynamicPageSourceType);
  const dynamicPagesSourceValue = useSelector(getContentModelDynamicPageSourceValue);
  const isSchedulingUpdate = useSelector(getIsSchedulingUpdate);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const shouldOpenPostPublishCustomDomainSetupModal = useSelector(getShouldOpenPostPublishCustomDomainSetupModal);
  const isEligibleForPostPublishContentRemixModal = useSelector(getShouldOpenPostPublishContentRemixModal);
  const domainIsConnected = useSelector(getActiveDomainIsConnected);
  const domainIsInternal = useSelector(getActiveDomainIsInternal);
  const isDndPage = useSelector(getHasAnyLayoutSections);
  const categoryId = useSelector(getCategoryId);
  const appState = useSelector(state => state);
  const contentId = useSelector(getContentModelId);
  const isUngatedForPublishWithContentCrmObject = useSelector(getIsUngatedForCMPPublishing);

  // TODO: to be replaced with CMP API in near future
  const baseContentUrl = getBaseContentUrl({
    baseUrl: useSelector(getBaseApiUrl),
    categoryId,
    subcategory: useSelector(getSubcategory),
    contentId
  });
  const endTourIfAny = () => {
    if (isFromPaymentsGuide()) {
      /**
       * For Payments Activation tours.
       * See https://product.hubteam.com/docs/commerce-pay-activation-fe-handbook/docs/userGuideOnboarding/post031.html
       *
       * This will make the tour sucess modal show up once websites are published.
       */
      const onboardingToursTask = getOnboardingToursTask();
      if (onboardingToursTask) {
        setShowUseCaseTourCompleteModal(true);
        markActionComplete(onboardingToursTask, {
          showTaskCompletionModal: false
        }).catch(error => Raven.captureException(error));
      }
    } else if (tour && tour.getStep() === 'publish') {
      tour.finish();
    }
  };
  const publishUnpublishAPICallback = isUnpublish => {
    return PublishApi.publish({
      baseContentUrl,
      timeout: 20000,
      unpublish: isUnpublish
    });
  };
  const refetchContent = () => {
    const params = {
      baseUrl: PAGES_API_BASE_URL
    };
    dispatch(fetchContent(params));
    dispatch(fetchHardSavedContent(params));
  };
  const triggerPostPublishModals = useCallback(publishType => {
    if (publishType === PublishTypes.publish) {
      if (shouldOpenPostPublishCustomDomainSetupModal) {
        dispatch(togglePostPublishDomainSetupModal(true));
        return;
      }
      if (isEligibleForPostPublishContentRemixModal) {
        dispatch(openModal(MODAL_TYPES.CONTENT_REMIX_POST_PUBLISH));
        return;
      }
    }
    if (!isFromPaymentsGuide()) {
      // Do not display UI Alert banner if in payments guided tour since we will display a modal instead
      displayPublishSuccessAlert({
        contentType: 'page',
        publishType: publishType,
        // TODO, avoid this non-null assertion
        publishedContentUrl: pageSettingsFullUrl,
        canScheduleWithContentCrmObject: isUngatedForPublishWithContentCrmObject
      });
    }
  }, [shouldOpenPostPublishCustomDomainSetupModal, isEligibleForPostPublishContentRemixModal, dispatch, pageSettingsFullUrl, isUngatedForPublishWithContentCrmObject]);
  const triggerPostPublishModalDiscoveryMode = async () => {
    await updateTaskStatus(DISCOVERY_MODE_GROUP_KEY, 'LANDING_PAGE', 'PUBLISHED');
    dispatch(openModal(DISCOVERY_MODE_STEP_COMPLETED_MODAL));
  };
  const onPublishSuccess = (__data, publishType) => {
    markActionComplete('explore-publish-site');
    markActionComplete('page-editor-demo', HIDE_TASK_COMPLETION_MODAL);
    if (isLandingPage) {
      markActionComplete('publish-landing-page');
      markActionComplete('create-landing-page');
      // Discovery Mode
      const {
        key,
        completed
      } = getOnboardingToursGuideSessionStorageValue();
      if (isBannerEnabled() && !completed && key === DISCOVERY_MODE_LANDING_PAGE_TASK_KEY) {
        void triggerPostPublishModalDiscoveryMode();
        return;
      }
    }
    if (!isUngatedForPublishWithContentCrmObject) {
      // TODO: Remove when API is updated so that publish-action returns the publishDate.
      // This is temp workaround to sync publishDate in FE state with BE after a publish.
      // We need this because publish-action updates publishDate AFTER our final pre-publish save request.
      fetchContentApi(baseContentUrl).then(({
        publishDate
      }) => {
        if (publishDate) {
          dispatch(updatePublishDate(publishDate));
        }
      }).catch();
    }
    if (isEligibleForThankYouPageReminder) {
      fetchThankYouPage({
        onCompleted: ({
          fetchPageById: {
            isDraft
          }
        }) => {
          if (isDraft) {
            dispatch(openModal(MODAL_TYPES.AILP_THANK_YOU_PAGE_REMINDER));
          } else {
            triggerPostPublishModals(publishType);
          }
        },
        onError: e => {
          logThankYouPageFetchError(e);
          triggerPostPublishModals(publishType);
        }
      });
    } else {
      triggerPostPublishModals(publishType);
    }
    showPagesCsatSurvey(notStarterCustomerish, publishType || PublishTypes.publish);
    refetchContent();
  };
  const onUnpublishSuccess = () => {
    refetchContent();
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.text"
      }),
      type: 'success'
    });
  };
  const trackPublishEvent = (isSuccessful, publishType) => {
    trackPublish({
      contentId,
      isConnectedAndCustomDomain: domainIsConnected && !domainIsInternal,
      isDndPage,
      publishType,
      usageTrackingProperties: {
        dynamicPagesSource,
        dynamicPagesSourceValue,
        isSchedulingUpdate
      },
      isSuccessful
    });
  };
  const onPublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  const onUnpublishError = errorResponse => {
    showPublishErrors(errorResponse.responseJSON || {}, categoryId, appState);
  };
  return {
    saveAction,
    endTourIfAny,
    publishUnpublishAPICallback,
    onPublishSuccess,
    onPublishError,
    onUnpublishSuccess,
    onUnpublishError,
    trackPublishEvent
  };
};
export default usePublishLifecycleHandlers;